<template>
<BootstrapDialog title="试题预览" ref="dialog" size="lg" @afterClose="afterClose()" :modal-style="{'width':'1200px'}">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
			<table border="0" cellpadding="0" cellspacing="0" class="tm_paper_question">
			    <div v-for = "(item,index) in model.stList" :key = "index">
			        <thead>
			            <tr>
			                <th valign="top" class="tm_question_lineheight"><cite>{{index+1}}</cite></th>
			                <td style="width:1100px;" class="tm_question_lineheight" v-html="item.sttg.replace('<p>','').replace('</p>','')"></td>
			            </tr>
			        </thead>
			        <tbody>
			                <tr>
			                <td colspan="2">
			                    <table class="optTbl">
			                        <tbody v-for = "(option,inde) in item.options" :key = "inde">
			                            <tr>
			                                <td class="optTbl_xz"> <div class="optTbl_xz_ys" style=""><label v-html="option.alisa"></label></div></td>
			                                <td style="text-align: left;" v-html="option.text"></td>
			                            </tr>
			                        </tbody>
			                    </table>
			                    <div class="div-key-container">
			                        <span style="margin-right: 5px;color: #417ac1;" >标准答案：</span>
			                        <span style="color: #417ac1;" v-if="item.stlb=='JUDGMENT'" v-html="item.stda =='Y'?'正确':'错误'"></span>
			                        <span style="color: #417ac1;" v-if="item.stlb!='JUDGMENT' && item.stlb!='BLANKFILL'" v-html="item.stda"></span>
			                        <span style="color: #417ac1;" v-for = "(blank,ind) in item.blanks" :key = "ind">
			                            <span v-html="blank.value+' '"></span>
			                        </span>
			                    </div>
			                    <div class="div-key-container">
			                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
			                        <span style="color: #2a8801;" v-html="item.stjx ? item.stjx.replace('<p>','').replace('</p>','') : ''" ></span>
			                    </div>
			                </td>
			            </tr>
			        </tbody>
			    </div>
			</table>
		</div>
	</template>
	<template v-slot:footer>
			<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 题库列表预览试题
     */
    export default {
        name: "QuesBankViewQues",
		components:{
		},
        data:function(){
            return {
				id:'',
                model:{
                    stList:[]
                }
            }
        },
        methods: {
			reset:function(){
				this.id='';
				this.model = {
				    stList:[]
				}
			},
			async open(params){
				this.id = params.id;
				let res = await this.$http.post('/htgl/zktk/tk/ylst',{id:this.id});
				if(res){
					this.model.stList = res.data;
				}
				this.$nextTick(()=>{
					this.$refs.dialog.open();
				});
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
        }

    }
</script>
<style scoped>
    .tm_paper_question {
        margin: 5px 0;
        border-bottom: dotted 1px #eee;
        width: 100%;
    }
    .tm_paper_question thead tr th {
        width: 40px;
        text-align: right;
        padding-right: 5px;
    }

    .tm_question_lineheight {
        line-height: 30px;
    }
    .tm_question_lineheight cite {
        background: #368ee0;
        padding: 0 5px;
        margin: 3px 5px;
        font-style: normal;
        color: #fff;
        min-width: 20px;
        display: block;
        text-align: center;
        line-height: 25px;
        border-radius: 13%;
    }
    .tm_question_lineheight {
        line-height: 30px;
    }
    .tm_paper_question tbody tr td {
        padding: 0 0 10px 0;
    }
    .div-key-container {
        margin: 5px 25px;
        border: dotted 1px #ddd;
        padding: 5px;
    }
    .div-key-container span {
        font-weight: bold;
    }
    .div-key-container {
        margin: 5px 25px;
        border: dotted 1px #ddd;
        padding: 5px;
    }
    label {
        margin-bottom:0;
        line-height: 24px;
        font-weight: 500;
    }
    .optTbl_xz{
        width: 40px;
        text-align: right;
    }
    .optTbl_xz_ys{
        padding: 0 5px;
        margin: 3px 5px 12px;
        font-style: normal;
        min-width: 20px;
        display: block;
        text-align: center;
        line-height: 25px;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        border: 1px solid rgb(115 115 115);
    }
    .optTbl {
        margin-left: 22px;
        margin-top: 10px;
    }

</style>